'use strict'

export let english={
  general: {
    title: "Organization",
    approach: "Approach",
    stakeholdersInDefinition: "Stakeholders as described in Project Definition",
    stakeholder: "stakeholder",
    readMore: "read more",
    hideDetails: "hide details",
    leavePage: "Leave this page",
    addRole: "Add role",
    assignRole: "Assign role",
    addRoleDetails: "add role details",
    cancel: "Cancel",
    update: "Update",
    addStakeholder: "Add stakeholder",
    newStakeholder: "New stakeholder",
    messageEmailFirst: "please provide email first",
    helpName: "Stakeholders full name"
  },

  roles: {
    title: "Role Descriptions",
    headings: {
      name: "Name",
      email:"Email",
      role: "Role",
      details: "Details"
    },
    project: {
      selectRole: "-- select project role --",
      actions: {
        appointExecutive: "Appoint Executive",
        appointProjectManager: "Appoint Project Manager",
      },
      descriptions: {
        board: {
          title: "Project Board",
          ingress: `The board is responsible for the overall direction and management of the project.
            The board is chaired by business (executive) and balanced with representatives for users and suppliers.`,
          details: `A project organization is built on the principle that there will always be three primary stakeholder categories: business, user and supplier.
            The following roles represent these stakeholder categories on the project board to ensure balanced direction given to the Project Manager`,
          responsibility: `The Project Board is responsible for the overall direction and management of the Project.
            Note that the Project Board is not a democracy controlled by vote. The Project Board is chaired by the Executive who is ultimately responsible`,
        },
        assuranceRoles: {
          title: "Assurance Roles",
          ingress: `The main Project Board members might need help, some deputies, to help and direct on a day-to-day basis. These are the assurance roles.`,
          details: `The deputy role for Senior Supplier is Supplier Assurance. The deputy role for Senior User is User Assurance. The deputy role for the Executive is Business Assurance.`
        },
        teamStructure: {
          title: "Team structure",
          details: `The purpose of the organization theme is to define and establish the project's structure, accountabilities and responsibilities (the who?). The project should have a Project Board chaired by the Executive. The Project Board should have one or several Senior User(s) and Senior Supplier(s) supporting the Executive. There should be a Team Manager for each discipline contributing in the project.`,
          additionalInformation: `One person can take several roles if the person has the capacity and competency, and if there is no conflict of interest.`
        }
      },
      roles: {
        executive: {
          title: "Executive",
          summary: "representing the business needs. It is considered mandatory to have one, and only one, Executive",
          ingress: `Is the ultimately responsible for the project with focus on achieving the objectives and delivering a product that achieves the benefits.`,
          details: `The Executive, sometimes called Sponsor or Project Owner, is ultimately responsible for the project
            and for decisions in directing the work, supported by Senior User and Senior Supplier.
            The Executive's role is to ensure that the project is focused throughout its life on achieving its
            objectives and delivering a product that will achieve the benefits, balancing demands from various stakeholders.  Throughout the project, the Project Owner is responsible for the Business Case.`,
          additionalInformation: `Appointing an Executive should be the very fist action.`
        },
        seniorUser: {
          title: "Senior User",
          summary: "representing the users of the project output. There can be one or several Senior Users on the Project Board",
          ingress: `Is representing users of the deliveries from the project and ensuring that the forecasted benefits are realized.`,
          details: `The Senior User is responsible for specifying the needs of those who will use the project's products, commits user resources and monitors products against such requirements. The Senior User specifies and assures furthermore the benefits and qualities and is held to account by demonstrating that the forecast benefits have in fact been realized.`
        },
        seniorSupplier: {
          title: "Senior Supplier",
          summary: "representing those who will create the project's output. There can be one or several Senior Suppliers on the Project Board",
          ingress: `Is representing the suppliers that will deliver the products in the project and accountable for the quality of these.`,
          details: `The Senior Supplier represents the interests of those designing, developing, facilitating, procuring and implementing the project&#8217;s products, secures the necessary resources and is accountable for the quality of products delivered by the supplier(s) as well as for the technical integrity.`
        },
        projectManager: {
          title: "Project Manager",
          ingress: `Runs the project on a day-to-day basis within constraints given by the board.`,
          details: `The Project Manager has the authority to run the project on a day-to-day basis within the given constraints.  The Project Manager's main responsibility is to ensure that the project produces the required products within the specified tolerances of time, cost, quality, scope, risk and benefits - and that the ultimate project's product(s) is capable of achieving the benefits defined in the Business Case.`,
          additionalInformation: `The Project Manager should be appointed when the project is starting up.`
        },
        teamManager: {
          title: "Team Manager",
          ingress: `Ensures that agreed products are produced in the project as defined by the project manager.`,
          details: `The Team Manager ensures production of those products defined by the Project Manager to an appropriate quality, in a timescale and at a cost acceptable to the Project Board. The Team Manager reports to and takes direction from the Project Manager. The Team Manager agrees the work with the Project Manager, plans the team&#8217;s work, supervise the team&#8217;s work and reports on quality and progress. The Team Manager obtains the approval for the completed products delivery.`
        }
      },
      executive: "Executive",
      seniorUser: "Senior User",
      seniorSupplier: "Senior Supplier",
      businessAssurance: "Business Assurance",
      projectManager: "Project Manager",
      teamManager: "Team Manager",
      projectSupport: "Project Support",
      changeAuthority: "Change Authority",
      stakeholder: "Stakeholder",
      userAssurance: "User Assurance",
      supplierAssurance: "Supplier Assurance",
      teamMember: "Team Member"
    },
    programme: {
      selectRole: "-- select programme role --",
      actions: {
        appointSRO: "Appoint Senior Responsible Owner",
        appointProgrammeManager: "Appoint Programme Manager"
      },
      descriptions: {
        teamStructure: {
          title: "Team Structure",
          details: `The purpose of the organization theme is to define and establish the programme's structure, accountabilities and responsibilities (the who?). The programme should have a Programme Board chaired by the Senior Responsible Owner.`,
          additionalInformation: `The Programme Board should have one or several Business Change Manager(s) responsible for realizing the benefits.`
        }
      },
      roles: {
        seniorResponsibleOwner: {
          title: "Senior Responsible Owner",
          details: "The Senior Responsible Owner (SRO) is accountable for the programme, ensuring it meets its objectives.",
          additionalInformation: "The induvidual who fulfills this role must have the seniority and authority to lead the programme board and must be empowered to direct the programme."
        },
        programmeManager: {
          title: "Programme Manager",
          details: `The Programme Manager has day-to-day management of the programme, is planning and designing the programme, is developing governance frameworks and is managing the programme's budget, risks and issues. `,
          additionalInformation: "The Programme Manager reports progress of the programme at regular intervals to the SRO and manages communication with stakeholders"
        }
      },
          seniorResponsibleOwner: "Senior Responsible Owner",
          programmeManager: "Programme Manager",
          businessChangeManager: "Business Change Manager",
          stakeholder :"Stakeholder",
          teamMember: "Team Member"
    },
    product: {
      selectRole: "-- select product role --",
      actions: {
        appointExecutive: "Appoint Executive",
        appointProductManager: "Appoint Product Manager"
      },
      descriptions: {
        teamStructure: {
          title: "Team Structure",
          details: `Efficient product teams need to cover viability, desirability and feasibility. The Product Manager should take care of viability, why something should be done. Someone also needs to be in charge of desirability, how the product needs to be for the user. Somethimes this is a designer`,
          additionalInformation: `Feasibility is making sure we know how the product should be made. A senior technical person should take this responsibility. Use the Team Manager role below to document the roles not explicitly listed.`
        }
      },
      roles: {
        executive: {
          title: "Executive",
          details: "The Executive the ultimately responsible for the success of the product with focus on achieving the objectives and delivering the benefits. It is considered mandatory to have one, and only one, Executive.",
          additionalInformation: "Appointing an Executive should be the very fist action. The Executive is somethimes called Sponsor or Owner."
        },
        productManager: {
          title: "Product Manager",
          details: "Product management responsibilities range from research on markets, customers and competitors, to developing and maintaining the product vision and roadmap. ",
          additionalInformation: "In this context, the product management responsibility in focus is working with product delivery teams to define, prioritize and test their delivery of product capabilities to maximize value and business impact."
        }
      },
          executive: "Executive",
          productManager: "Product Manager",
          teamManager: "Team Manager",
          stakeholder: "Stakeholder",
          teamMember: "Team Member"
    }
  },

  teamStructure: {
    title: "Team Structure"
  },
  communicationManagementApproach: {
    title: "Communication Management Approach",
    description: "The communication management approach describes how information will be shared in the project team and how the project team will send information to, and receive information from, project stakeholders.",
    fields: {
      process: {
        title: "Communication Procedure",
        help: `Will the project have any rules, routines or processes ensuring relevant information is shared in the project team, with the stakeholders, with the larger organization or with 3rd parties?
          Are there any standard procedures or policies to be followed on communication? Any planned deviation from these procedures? If so, why?
          How will we make sure the procedure is followed?
          Any standards or templates to be used?
          How will the communication procedure work with 3rd parties?
          How will the project handle classified information and data privacy?`,
        description: "Describe the communication methods and procedures to be used within the project and externally to the project"
      },
      tools: {
        title: "Tools, Techniques and Records",
        help: `Which techniques and communication tools will be used to share information?
          Will there be any logging of internal or external communication?
          Will the project use social media, e-mail, blogs, intranets, meetings, workshops, letters, documents ?`,
        description: "Describe what tools or techniques the project will apply to make sure all needed information is shared."
      },
      reporting: {
        title: "Reporting",
        help: `When will formal communication occur?
          Any specific communication activities in Initiation, beginning/end of stages or in closing?`,
        description: "The communication reports to be produced, their purpose, timing and recipients."
      },
      timing: {
        title: "Timing of communication",
        help: `When will formal communication occur? When will meetings occour?
          Any specific communication activities in Initiation, beginning/end of stages or in closing?`,
        description: "Describe the timing of formal communication activities"
      },
      roles: {
        title: "Roles and responsibilities",
        help: `Who is responsible for the communication policy/procedure?
          Who makes decisions on what can be communicated and when?
          Who is responsible for communicating what to whom?`,
        description: "Define the roles and responsibilities for communication",
      }
    }
  },
  stakeholderAnalysis: {
    title: "Stakeholder Analysis",
    fields: {
      stakeholders: {
        title: "Communication to stakeholders",
        columns: {
          name: { title: "Stakeholder" },
          message: { title: "Key messages" },
          requiredInformation: { title: "Information required" },
          providedInformation: { title: "Information provided" },
          frequency: {title: "Frequency" }
        },
        options: {
          addEntry: {
            title: "Add stakeholder"
          }
        }
      }
    }
  },
  stakeholder: {
    title: "Stakeholder",
    fields: {
      name: {
        title: "Stakeholder name",
        help: `Who has a financial stake/interest?
          Who controls resources?
          Who will be affected?
          Any owners or auditors of policies and procedures?
          Who are the biggest supporters?
          Who are the biggest non-supporters or naysayers?
          Any external partners, competitors or users?`,
        description: "Name, role or group"
      },
      message: {
        title: "Key messages",
        help: "What is the key message to this stakeholder?",
        description: "The key message to this stakeholder"
      }
    }
  },
  information: {
    title: "Information",
    fields: {
      requiredInformation: {
        title: "Information required from the project",
        help: `What information will this stakeholder ask for?
          What information do we want this stakeholder to receive?
          Is there information the stakeholder doesn't want to receive?
          Is there specific information we don't want to share with this stakeholder?`,
        description: "The information communicated from the project to this stakeholder"
      },
      providedInformation: {
        title: "Information required to the project",
        help: `Is the project relying on information from this stakeholder? If so, what type of information is it?`,
        description: "The information required to be provided to the project from this stakeholder"
      }
    }
  },
  communication: {
    title: "Communication",
    fields: {
      frequency: {
        title: "Frequency of communication",
        help: `How often should the project communicate with this stakeholder?
          Will the frequency vary depending on the type of information?`,
        description: "Describe the frequency of communication to this stakeholder"
      },
      means: {
        title: "Means of communication",
        help: `What method will be used to communicate with this stakeholder?
          What will be the communication vehicle? Meetings, digital tools?`,
        description: "Means"
      },
      format: {
        title: "Format of communication",
        help: `What format will be used to share the information?
          Document, presentation, video, pictures, spoken, long, short, content rich/poor?`,
        description: "Format"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/organization/labels/english.js